import React, { createContext, useContext, useState, useCallback } from 'react';

const LanguageContext = createContext(null);

const translations = {
  en: {
    enterLive: "Enter the Live",
    learnMore: "Learn More",
    heroTitle: "Where Connections",
    heroHighlight: "Spark",
    heroSub: "Premium live video dating with interactive party games. Meet fascinating people in a safe, consent-first environment.",
    only18: "Only 18+",
    consentFirst: "Consent-first experience",
    safeModerated: "Safe & moderated",
    whyChoose: "Why Choose",
    premiumExp: "A premium experience designed for meaningful connections",
    liveVideoRooms: "Live Video Rooms",
    liveVideoDesc: "Connect face-to-face with fascinating people in real-time",
    interactiveGames: "Interactive Games",
    gamesDesc: "Break the ice with Hot Seat, Red Flag/Green Flag, and more",
    communityEvents: "Community Events",
    eventsDesc: "Join themed parties and meet people who share your vibe",
    safeEnvironment: "Safe Environment",
    safeDesc: "Consent-first approach with powerful moderation tools",
    partyGames: "Party Games",
    partyGamesDesc: "Break the ice and have fun with our interactive games",
    hotSeat: "Hot Seat",
    hotSeatDesc: "Answer flirty questions voted by the audience",
    redFlagGreenFlag: "Red Flag / Green Flag",
    rfgfDesc: "Vote on relationship scenarios together",
    truthOrDare: "Truth or Dare Lite",
    todDesc: "Fun challenges and questions (always skippable!)",
    readyToConnect: "Ready to Connect?",
    joinThousands: "Join thousands of people making real connections every day",
    ageTitle: "Age Verification Required",
    ageSub: "FlirtyLive is a platform for adults only (18+). By continuing, you confirm you are of legal age.",
    iConfirm: "I confirm I am 18+ years old",
    iAgree: "I agree to the Community Guidelines",
    enterPlatform: "Enter Platform",
    login: "Login",
    signup: "Sign Up",
    username: "Username",
    password: "Password",
    displayName: "Display Name",
    demoAccess: "Try Demo Access",
    orContinueWith: "or continue with",
    home: "Home",
    goLive: "Go Live",
    profile: "Profile",
    search: "Search rooms...",
    liveNow: "Live Now",
    viewers: "viewers",
    noRooms: "No live rooms right now. Be the first to go live!",
    roomTitle: "Room Title",
    tags: "Tags",
    selectCamera: "Select Camera",
    selectMic: "Select Microphone",
    startLive: "Start Live",
    preview: "Camera Preview",
    chat: "Chat",
    sendMessage: "Send a message...",
    send: "Send",
    endStream: "End Stream",
    mute: "Mute",
    unmute: "Unmute",
    cameraOn: "Camera On",
    cameraOff: "Camera Off",
    report: "Report",
    block: "Block",
    warn: "Warn",
    games: "Games",
    safetyReminder: "Remember: All interactions must be consensual. Report any inappropriate behavior.",
    skip: "Skip",
    next: "Next",
    truth: "Truth",
    dare: "Dare",
    redFlag: "Red Flag",
    greenFlag: "Green Flag",
    vote: "Vote",
    startGame: "Start Game",
    waitingPlayers: "Waiting for players...",
    about: "About",
    streams: "Streams",
    achievements: "Achievements",
    editProfile: "Edit Profile",
    followers: "Followers",
    following: "Following",
    totalStreams: "Total Streams",
    totalViews: "Total Views",
    level: "Level",
    tokens: "Tokens",
  },
  it: {
    enterLive: "Entra nella Live",
    learnMore: "Scopri di pi\u00f9",
    heroTitle: "Dove le Connessioni",
    heroHighlight: "Scintillano",
    heroSub: "Video dating live premium con giochi di gruppo interattivi. Incontra persone affascinanti in un ambiente sicuro e consensuale.",
    only18: "Solo 18+",
    consentFirst: "Esperienza consensuale",
    safeModerated: "Sicuro e moderato",
    whyChoose: "Perch\u00e9 Scegliere",
    premiumExp: "Un'esperienza premium per connessioni significative",
    liveVideoRooms: "Stanze Video Live",
    liveVideoDesc: "Connettiti faccia a faccia con persone affascinanti in tempo reale",
    interactiveGames: "Giochi Interattivi",
    gamesDesc: "Rompi il ghiaccio con Hot Seat, Red Flag/Green Flag e altro",
    communityEvents: "Eventi Community",
    eventsDesc: "Unisciti a feste a tema e incontra persone con il tuo stesso vibe",
    safeEnvironment: "Ambiente Sicuro",
    safeDesc: "Approccio consensuale con potenti strumenti di moderazione",
    partyGames: "Giochi di Gruppo",
    partyGamesDesc: "Rompi il ghiaccio e divertiti con i nostri giochi interattivi",
    hotSeat: "Hot Seat",
    hotSeatDesc: "Rispondi a domande flirty votate dal pubblico",
    redFlagGreenFlag: "Red Flag / Green Flag",
    rfgfDesc: "Vota insieme sugli scenari relazionali",
    truthOrDare: "Obbligo o Verit\u00e0 Lite",
    todDesc: "Sfide e domande divertenti (sempre saltabili!)",
    readyToConnect: "Pronto a Connetterti?",
    joinThousands: "Unisciti a migliaia di persone che creano connessioni reali ogni giorno",
    ageTitle: "Verifica Et\u00e0 Richiesta",
    ageSub: "FlirtyLive \u00e8 una piattaforma solo per adulti (18+). Continuando, confermi di avere l'et\u00e0 legale.",
    iConfirm: "Confermo di avere 18+ anni",
    iAgree: "Accetto le Linee Guida della Community",
    enterPlatform: "Entra nella Piattaforma",
    login: "Accedi",
    signup: "Registrati",
    username: "Nome utente",
    password: "Password",
    displayName: "Nome visualizzato",
    demoAccess: "Prova Accesso Demo",
    orContinueWith: "oppure continua con",
    home: "Home",
    goLive: "Vai Live",
    profile: "Profilo",
    search: "Cerca stanze...",
    liveNow: "In Diretta",
    viewers: "spettatori",
    noRooms: "Nessuna stanza live al momento. Sii il primo ad andare live!",
    roomTitle: "Titolo Stanza",
    tags: "Tag",
    selectCamera: "Seleziona Camera",
    selectMic: "Seleziona Microfono",
    startLive: "Inizia Live",
    preview: "Anteprima Camera",
    chat: "Chat",
    sendMessage: "Scrivi un messaggio...",
    send: "Invia",
    endStream: "Termina Stream",
    mute: "Muta",
    unmute: "Attiva Audio",
    cameraOn: "Camera Attiva",
    cameraOff: "Camera Spenta",
    report: "Segnala",
    block: "Blocca",
    warn: "Avvisa",
    games: "Giochi",
    safetyReminder: "Ricorda: Tutte le interazioni devono essere consensuali. Segnala qualsiasi comportamento inappropriato.",
    skip: "Salta",
    next: "Avanti",
    truth: "Verit\u00e0",
    dare: "Obbligo",
    redFlag: "Red Flag",
    greenFlag: "Green Flag",
    vote: "Vota",
    startGame: "Inizia Gioco",
    waitingPlayers: "In attesa dei giocatori...",
    about: "Info",
    streams: "Stream",
    achievements: "Obiettivi",
    editProfile: "Modifica Profilo",
    followers: "Follower",
    following: "Seguiti",
    totalStreams: "Stream Totali",
    totalViews: "Visualizzazioni",
    level: "Livello",
    tokens: "Token",
  }
};

function detectInitialLang() {
  const saved = localStorage.getItem('flirtylive_lang');
  if (saved === 'it' || saved === 'en') return saved;
  const candidates = navigator.languages && navigator.languages.length
    ? navigator.languages
    : [navigator.language || navigator.userLanguage || ''];
  return candidates.some(l => (l || '').toLowerCase().startsWith('it')) ? 'it' : 'en';
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(detectInitialLang);

  const toggleLanguage = useCallback(() => {
    setLang(prev => {
      const next = prev === 'en' ? 'it' : 'en';
      localStorage.setItem('flirtylive_lang', next);
      return next;
    });
  }, []);

  const t = useCallback((key) => {
    return translations[lang]?.[key] || translations.en[key] || key;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}
